import { cn } from "@/lib/utils/common";

function Heading1({ className, children, title }: { className?: string; children: React.ReactNode; title?: string }) {
  return (
    <h1 role="heading" className={cn("scroll-m-20 text-3xl font-bold lg:text-4xl", className)} title={title}>
      {children}
    </h1>
  );
}

function Heading2({ className, children }: { className?: string; children: React.ReactNode }) {
  return (
    <h2 className={cn("scroll-m-20 pb-2 text-2xl font-semibold tracking-tight first:mt-0", className)}>{children}</h2>
  );
}

function Heading3({ className, children }: { className?: string; children: React.ReactNode }) {
  return <h3 className={cn("scroll-m-20 text-xl font-semibold tracking-tight", className)}>{children}</h3>;
}

function Heading4({ className, children }: { className?: string; children: React.ReactNode }) {
  return <h4 className={cn("scroll-m-20 text-lg font-semibold tracking-tight", className)}>{children}</h4>;
}

function Paragraph({ className, children }: { className?: string; children: React.ReactNode }) {
  return <p className={cn("my-2 leading-7", className)}>{children}</p>;
}

export { Heading1, Heading2, Heading3, Heading4, Paragraph };
